import React from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import { Row } from "../../components/Base";

export const OrderPaidSuccess = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Typography variant="h4">{t("payment.courses_ready")}</Typography>
      </Row>
    </>
  );
};

export const OrderPaidSuccessUpdateFailed = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Typography variant="h4">{t("payment.paid_processing_error")}</Typography>
      </Row>
      <Row>
        <Typography>{t("payment.wait_for_receipt")}</Typography>
      </Row>
      <Typography>
        {t("payment.contact_support")} <a href="mailto:support@ngft.com">support@ngft.com</a>
      </Typography>
    </>
  );
};

export const OrderPaidFail = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Typography variant="h4">{t("payment.processing_error")}</Typography>
      </Row>
      <Row>
        <Typography>{t("payment.processing_error_detail")}</Typography>
      </Row>
      <Typography>
        {t("payment.contact_support")} <a href="mailto:support@ngft.com">support@ngft.com</a>
      </Typography>
    </>
  );
};
